export class OrbitLeaderboardSummary {
  totalTxs: number = 0
  poolParticipations: number = 0
  poolClaims: number = 0
  totalGasRewards: number = 0
}
